import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Article from "../pages/article/page";
import KakobuyArticle from "../pages/kakobuy-guide/page";
import CssbuyArticle from "../pages/cssbuy-guide/page";
import SuperbuyArticle from "../pages/superbuy-guide/page";
import OopbuyArticle from "../pages/oopbuy-guide/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/hipobuy-spreadsheet-guide",
    element: <Article />,
  },
  {
    path: "/kakobuy-spreadsheet-guide",
    element: <KakobuyArticle />,
  },
  {
    path: "/cssbuy-spreadsheet-guide",
    element: <CssbuyArticle />,
  },
  {
    path: "/superbuy-spreadsheet-guide",
    element: <SuperbuyArticle />,
  },
  {
    path: "/oopbuy-spreadsheet-guide",
    element: <OopbuyArticle />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;